import script from "./LeadsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadsTable.vue?vue&type=script&setup=true&lang=js"

import "./LeadsTable.vue?vue&type=style&index=0&id=3571caef&lang=css"

const __exports__ = script;

export default __exports__